import { Card, Flex, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

type CardUIProps = {
  id?: number;
  imageUrl?: string;
  name?: string;
};

export const CardUI = ({ id = 0, imageUrl = "", name = "" }: CardUIProps) => {
  return (
    <Card.Root size={"sm"}>
      <Card.Body>
        <Flex flexFlow={"column"} align={"center"}>
          <Text> No.{id}</Text>
          <Link to={`/pokemons/${id}`}>
            <Image
              src={imageUrl}
              alt="Image"
              _hover={{ transform: "scale(1.5)" }}
            />
          </Link>
          <Text fontWeight="bold">{name}</Text>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
